import AxiosClient from "../../../services/axios.services";

class DisciplinaryCaseServices {
  getDisciplinaryCases = (params) =>
    // AxiosClient.get("/api/app/sanciones_caso_disciplinario/",{
    AxiosClient.get("/api/app/new_sanciones_casos_disciplinarios/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getDisciplinaryCase = (id) =>
    AxiosClient.get(`/api/app/sanciones_caso_disciplinario/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });

  saveDisciplinaryCase = (data) =>
    AxiosClient.post("/api/app/sanciones_caso_disciplinario/", data, {
      headers: { "Content-Type": "application/json" },
    });

  saveRequirementsUrl = (data) =>
    AxiosClient.post(
      "/api/app/sanciones_casos_disciplinarios_archivos/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editDisciplinaryCase = (id, data) =>
    AxiosClient.put(`/api/app/sanciones_caso_disciplinario/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });

  deleteDisciplinaryCase = (id) =>
    AxiosClient.delete(`/api/app/sanciones_caso_disciplinario/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });

  envioCorreo = (data) =>
    AxiosClient.post(`/api/app/sanciones_envio_correo/`, data, {
      headers: { "Content-Type": "application/json" },
    });

  postComment = (data) =>
    AxiosClient.post(
      `/api/app/sanciones_casos_disciplinarios_crear_comentario/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  getComments = (id) =>
    AxiosClient.get(
      `/api/app/sanciones_casos_disciplinarios_comentarios/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  getRequirementDoc = (id) =>
    AxiosClient.get(`/api/app/sanciones_casos_disciplinarios_archivos/${id}/`, {
      headers: { responseType: "blob" },
    });
}

export default new DisciplinaryCaseServices();
